import React, { LabelHTMLAttributes } from 'react';
import labelStyles from '@danske/sapphire-css/components/label/label.module.css';
import intlMessages from '../i18n';
import clsx from 'clsx';
import { useMessageFormatter } from '@react-aria/i18n';
import { GlobalDomAttributes } from '../../utils/types';

export type LabelProps = LabelHTMLAttributes<HTMLLabelElement> &
  GlobalDomAttributes & {
    /**
     * @default 'lg'
     */
    size?: 'lg' | 'md';
    /**
     * A HelpButton to render next to the label.
     */
    contextualHelp?: React.ReactNode;
    /**
     * To visually indicate if this field is required or optional.
     */
    necessityIndicator?: 'required' | 'optional';
    children?: React.ReactNode;
  };

export const Label = ({
  size = 'lg',
  contextualHelp,
  necessityIndicator,
  children,
  ...htmlLabelProps
}: LabelProps): React.JSX.Element => {
  const formatMessage = useMessageFormatter(intlMessages);

  return (
    <div
      className={clsx(labelStyles['sapphire-label'], {
        [labelStyles['sapphire-label--md']]: size === 'md',
      })}
    >
      <label
        className={clsx(labelStyles['sapphire-label__text'])}
        {...htmlLabelProps}
      >
        {children}
      </label>
      {necessityIndicator === 'required' ? (
        <span
          className={clsx(labelStyles['sapphire-label__required-indicator'])}
        ></span>
      ) : necessityIndicator === 'optional' ? (
        <span
          className={clsx(labelStyles['sapphire-label__optional-indicator'])}
        >
          ({formatMessage('optional')})
        </span>
      ) : null}
      {contextualHelp ? (
        <span className={clsx(labelStyles['sapphire-label__help-button'])}>
          {contextualHelp}
        </span>
      ) : null}
    </div>
  );
};
